/* eslint-disable ember/no-computed-properties-in-native-classes */
import Model, {
  attr,
  belongsTo,
  type AsyncBelongsTo,
} from '@warp-drive/legacy/model';
import { computed } from '@ember/object';
import { alias } from '@ember/object/computed';
import { isEmpty } from '@ember/utils';
import type { Type } from '@warp-drive/core/types/symbols';
import type { StatefulArray } from 'ember-data-model-fragments/array/stateful';
import { array } from 'ember-data-model-fragments/attributes';
import type RollReturn from 'linced-app/models/nz-roll-returns/roll-return';
import type Person from 'linced-app/models/person';

// Proto: nz_moe_roll_returns.ValidationResult.
export default class ValidationResult extends Model {
  declare [Type]: 'nz-roll-returns/validation-result';

  @attr('number')
  declare createTime: number | undefined;

  @attr('number')
  declare updateTime: number | undefined;

  @belongsTo('person', { async: true, inverse: null })
  declare personId: AsyncBelongsTo<Person>;

  @alias('personId')
  declare person: AsyncBelongsTo<Person>;

  @array('string')
  declare warnings: StatefulArray<string>;

  // TS-BUG: this replaces Model.errors, so a save cannot record validation
  // errors (same as common cron/process-monitor, HE-161).
  @array('string')
  // @ts-expect-error The array attr replaces the Model.errors accessor.
  declare errors: StatefulArray<string>;

  @computed('warnings.[]')
  get sortedWarnings() {
    const warnings = this.warnings.slice();
    warnings.sort();
    return warnings;
  }

  @computed('errors.[]')
  get sortedErrors() {
    const errors = this.errors.slice();
    errors.sort();
    return errors;
  }

  @belongsTo('nz-roll-returns/roll-return', {
    async: true,
    inverse: 'validationResults',
  })
  declare rollReturnId: AsyncBelongsTo<RollReturn>;

  @alias('rollReturnId')
  declare rollReturn: AsyncBelongsTo<RollReturn>;

  @computed('errors.length')
  get isValid() {
    return isEmpty(this.errors);
  }

  @computed('warnings.length')
  get hasWarnings() {
    return this.warnings.length > 0;
  }
}
